/**
 * GoogleMapsAPI Loader Module
 *
 * Returns a promise that resolves with the google.maps object when all of the google maps api loading process is complete
 *
 * Example Usage:
 *
 *  define([ 'app/lib/google-maps-loader' ], function(GoogleMapsLoader){
 *      GoogleMapsLoader.done(function(GoogleMaps){
 *          // your google maps code here!
 *          var geocoder = new GoogleMaps.Geocoder();
 *      }).fail(function(){
 *          console.error("ERROR: Google maps library failed to load");
 *      });
 *  });
 *
 *  -OR-
 *
 *  define([ 'app/lib/google-maps-loader' ], function(GoogleMapsLoader){
 *      GoogleMapsLoader.done(function(){
 *          // your google maps code here!
 *          var geocoder = new google.maps.Geocoder();
 *      }).fail(function(){
 *          console.error("ERROR: Google maps library failed to load");
 *      });
 *  });
 *
 */

let promise = null
window.googleMapsAPILoaded = () => {
  if (window.google && window.google.maps) {
    promise.resolve(window.google.maps)
  }
  else {
    promise.reject(new Error('GoogleMaps API Error'))
  }
}

function loadGoogleMaps({
  key
  // sensor = true
}) {
  if (!key) {
    return Promise.reject(new Error('GoogleMaps key missing'))
  }

  if (promise) {
    return promise.promise
  }

  promise = {}

  promise.promise = new Promise((resolve, reject) => {
    promise.resolve = resolve
    promise.reject = reject

    const url = `//maps.googleapis.com/maps/api/js?key=${key}&callback=googleMapsAPILoaded` // &sensor=${sensor}

    try {
      const script = document.createElement('script')
      script.src = url
      document.body.appendChild(script)
    }
    catch (ex) {
      reject(ex)
    }
  })

  return promise.promise
}

const MAX_TRIES = 1

export default {
  load(opts) {
    if (window.google && window.google.maps) {
      return Promise.resolve(window.google.maps)
    }
    let tries = 0
    return new Promise((resolve, reject) => {
      const loadGoogleMapsInterval = window.setInterval(() => {
        tries += 1
        if (tries > MAX_TRIES) {
          window.clearInterval(loadGoogleMapsInterval)
          reject(new Error(`Could not load GoogleMaps API in ${MAX_TRIES} tries`))
        }

        loadGoogleMaps(opts)
          .then((res) => {
            window.clearInterval(loadGoogleMapsInterval)
            resolve(res)
          })
          .catch((ex) => {
            window.clearInterval(loadGoogleMapsInterval)
            reject(ex)
          })
      }, 1000)
    })
  }
}



// WEBPACK FOOTER //
// ./src/shared/libs/google-maps-api-loader.js